import { paths } from '@acs/shared';
import { collection, limit, onSnapshot, orderBy, query, where, type QueryConstraint } from 'firebase/firestore';
import { callConverter, type CallDoc } from './converters.js';
import { db } from './firebase.js';

/** Inclusive date-range filter on a call's `startedAt` (both bounds optional). */
export interface CallDateRange {
  from?: Date;
  to?: Date;
}

/**
 * Live subscription to recent call history (most recent first), optionally
 * bounded to a `startedAt` date range. The range predicate is on the same field
 * as the sort, so it needs no composite index.
 */
export function subscribeCalls(
  businessId: string,
  range: CallDateRange,
  cb: (rows: CallDoc[]) => void,
  /** Row cap. The default suits a browsable list; aggregations (the dashboard
   *  KPI strip) raise it so a busy week isn't silently truncated. */
  max = 50,
): () => void {
  const constraints: QueryConstraint[] = [];
  if (range.from) constraints.push(where('startedAt', '>=', range.from));
  if (range.to) constraints.push(where('startedAt', '<=', range.to));
  constraints.push(orderBy('startedAt', 'desc'), limit(max));

  const q = query(collection(db, paths.calls(businessId)).withConverter(callConverter), ...constraints);
  return onSnapshot(q, (snap) => cb(snap.docs.map((d) => d.data())));
}
